import React from 'react';
import { PdfImageComponent, PdfImageFit } from '../PdfComponent';
import { usePdfTemplateContext } from '../PdfTemplateEditorContext';

export default function PdfTemplateImagePreview<T>({ component }: { component: PdfImageComponent }) {
  const { updateComponent, fsToPtScaled } = usePdfTemplateContext<T>();
  return (
    <div
      className='flex h-full w-full items-center justify-center overflow-hidden bg-white'
      onDragOver={e => {
        if (e.dataTransfer.types.includes('Files')) {
          e.preventDefault();
        }
      }}
      onDrop={e => {
        const file = e.dataTransfer.files?.[0];
        if (!file) return;
        e.preventDefault();
        const reader = new FileReader();
        reader.onload = () => {
          const dataUrl = String(reader.result);
          const imgEl = new Image();
          imgEl.onload = () => {
            updateComponent(component.id, {
              src: dataUrl,
              naturalWidthPx: imgEl.naturalWidth,
              naturalHeightPx: imgEl.naturalHeight,
            });
          };
          imgEl.src = dataUrl;
        };
        reader.readAsDataURL(file);
      }}
    >
      {component.src ? (
        <img
          src={component.src}
          alt='uploaded'
          draggable={false}
          onDragStart={e => e.preventDefault()}
          style={{
            width: '100%',
            height: '100%',
            objectFit: component.fit === PdfImageFit.autoScale ? 'scale-down' : component.fit,
            opacity: component.opacity ?? 1,
            userSelect: 'none',
          }}
        />
      ) : (
        <span style={{ fontSize: fsToPtScaled() }} className='select-none text-gray-500'>
          Drop or upload image in Properties
        </span>
      )}
    </div>
  );
}
